import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService} from '../../shared';
import {MembershipPeriodLineContainerModel} from '../../../../../../models/aggregates/crm/membership-suspension';
import {Core2Config} from '../../shared';
import { Observable } from 'rxjs';
import { MemberSuspensionRemarksDtoModel } from '../../../data-transfer-objects';


@Injectable({
  providedIn: 'root'
})
export class MembershipSuspensionService extends BaseApiTemplateService<MembershipPeriodLineContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.CRM_PREFIX + 'membership-period-lines/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL +  Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.CRM_PREFIX + 'membership-period-lines/backoffice-ep';
    this.endpoint_path =  Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.CRM_PREFIX + 'membership-period-lines/backoffice-ep';
    this.httpClient = http;
  }

  updateRemarks(dtoObject: MemberSuspensionRemarksDtoModel, apiVisa: ApiVisa){
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(apiVisa)
    );
  }
}


